"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.borderWidth = void 0;
/**
 * DO NOT MODIFY
 * Generated from scripts/codegen/main.ts
 */
const borderWidth = {
  none: 0,
  button: 1,
  card: 1,
  checkbox: 2,
  radio: 2,
  sparkline: 2,
  focusRing: 2,
  input: 1
};
exports.borderWidth = borderWidth;